/*
 * @Date: 2024-12-02 17:52:01
 * @Description:资讯管理
 */
import AppInformationMgmtList from '../views/information-mgmt-list.vue';
import AppInformationMgmtEdit from '../views/information-mgmt-edit.vue';

export const route = [
  {
    path: '/main/industry/information-mgmt',
    name: 'main-industry-information-mgmt',
    redirect: '/main/industry/information-mgmt/list',
    meta: {
      title: '资讯管理',
      platFrom: 'industry'
    },
    children: [
      {
        path: '/main/industry/information-mgmt/list',
        name: 'main-industry-information-mgmt-list',
        meta: {
          title: '资讯管理'
        },
        component: AppInformationMgmtList
      },
      {
        path: '/main/industry/information-mgmt/add',
        name: 'main-industry-information-mgmt-add',
        meta: {
          parentPath: '/main/industry/information-mgmt/list',
          title: '新增资讯'
        },
        component: AppInformationMgmtEdit
      },
      {
        path: '/main/industry/information-mgmt/edit',
        name: 'main-industry-information-mgmt-edit',
        meta: {
          parentPath: '/main/industry/information-mgmt/list',
          title: '编辑资讯'
        },
        component: AppInformationMgmtEdit
      }
    ]
  },
  {
    path: '/main/asp/information-mgmt',
    name: 'main-asp-information-mgmt',
    redirect: '/main/asp/information-mgmt/list',
    meta: {
      title: '资讯管理',
      platFrom: 'asp'
    },
    children: [
      {
        path: '/main/asp/information-mgmt/list',
        name: 'main-asp-information-mgmt-list',
        meta: {
          title: '资讯管理'
        },
        component: AppInformationMgmtList
      },
      {
        path: '/main/asp/information-mgmt/add',
        name: 'main-asp-information-mgmt-add',
        meta: {
          parentPath: '/main/asp/information-mgmt/list',
          title: '新增资讯'
        },
        component: AppInformationMgmtEdit
      },
      {
        path: '/main/asp/information-mgmt/edit',
        name: 'main-asp-information-mgmt-edit',
        meta: {
          parentPath: '/main/asp/information-mgmt/list',
          title: '编辑资讯'
        },
        component: AppInformationMgmtEdit
      }
    ]
  }
];
